<template>
  <div class="m-grid__item m-grid__item--fluid m-wrapper">
    <div class="m-subheader ">
      <div class="d-flex align-items-center">
        <div class="mr-auto">
          <h3 class="m-subheader__title m-subheader__title--separator">
            {{ 'user_administration' | titleize }}
          </h3>
          <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
          </ul>
        </div>
      </div>
    </div>
    <div class="m-content">
      <div class="m-portlet m-portlet--tab">
        <div class="m-portlet__head">
          <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
              <span class="m-portlet__head-icon m--hide">
                <i class=""></i>
              </span>
              <h3 class="m-portlet__head-text">{{ 'permissions' | capitalize }}</h3>
            </div>
          </div>
          <div class="m-portlet__head-tools">
            <button v-if="validPermission('create','permission')" id="btn-newpermission" class="btn btn-success m-btn m-btn--icon" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#permission_modal" @click="updateModalStatus(true)">
              <span><i class="fa fa-plus-circle"></i><span>{{ 'create_permission' | capitalize }}</span></span>
            </button>
          </div>
        </div>
        
        <router-view></router-view>

      </div>
      <s-modal id="permission_modal" :title="(modal_phrases) ? 'create_phrases' : (!is_edit) ? 'create_permission' : 'edit_permission' | translate | capitalize">
        <s-base-form v-show="!modal_phrases" slot="body" :pModel="model" :isProfile="false" :isEdit="is_edit"></s-base-form>
        <s-new-phrase v-show="modal_phrases" slot="body" :openOutside="true"></s-new-phrase>
      </s-modal>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import SModal from '@/components/layout/modal/Modal.vue'
  import SBaseForm from '@/components/admin/BaseForm.vue'
  import SNewPhrase from '@/components/admin/languages/phrases/New.vue'
  export default {
    data () {
      return {
        model: {
          names: {},
          description: '',
          state: 1
        },
        is_edit: false,
        phrase: {}
      }
    },
    created () {
      let language = this.$i18n.locale
      this.$store.dispatch('profiles')
      this.$store.dispatch('permissions', language)
    },
    computed: {
      ...mapGetters({edit_status: 'getEditStatus',
        edit_permission: 'getIdEditPermission',
        modal_phrases: 'getModalPhraseStatus',
        permissions: 'getUserPermissions'})
    },
    methods: {
      ...mapActions(['updateModalStatus']),
      validPermission (action, entity) {
        if (this.permissions.find(p => { return (p.action === action && p.entity === entity) })) {
          return true
        } else {
          return false
        }
      }
    },
    watch: {
      edit_status (newVal, oldVal) {
        if (oldVal === false && newVal === true) {
          this.model = this.edit_permission
          this.is_edit = true
        } else {
          this.model = { names: {}, state: 1 }
          this.is_edit = false
        }
      }
    },
    components: { SNewPhrase, SBaseForm, SModal }
  }
</script>



// WEBPACK FOOTER //
// Permissions.vue